module.exports = __webpack_public_path__ + "media/icons/x-sm-9d342857.svg";